import startCase from 'lodash-es/startCase'

const contiguousStates = {
  alabama: 'AL',
  arizona: 'AZ',
  arkansas: 'AR',
  california: 'CA',
  colorado: 'CO',
  connecticut: 'CT',
  delaware: 'DE',
  'district of columbia': 'DC',
  florida: 'FL',
  georgia: 'GA',
  hawaii: 'HI',
  idaho: 'ID',
  illinois: 'IL',
  indiana: 'IN',
  iowa: 'IA',
  kansas: 'KS',
  kentucky: 'KY',
  louisiana: 'LA',
  maine: 'ME',
  maryland: 'MD',
  massachusetts: 'MA',
  michigan: 'MI',
  minnesota: 'MN',
  mississippi: 'MS',
  missouri: 'MO',
  montana: 'MT',
  nebraska: 'NE',
  nevada: 'NV',
  'new hampshire': 'NH',
  'new jersey': 'NJ',
  'new mexico': 'NM',
  'new york': 'NY',
  'north carolina': 'NC',
  'north dakota': 'ND',
  'northern mariana islands': 'NP',
  ohio: 'OH',
  oklahoma: 'OK',
  oregon: 'OR',
  pennsylvania: 'PA',
  'rhode island': 'RI',
  'south carolina': 'SC',
  'south dakota': 'SD',
  tennessee: 'TN',
  texas: 'TX',
  utah: 'UT',
  vermont: 'VT',
  virginia: 'VA',
  washington: 'WA',
  'west virginia': 'WV',
  wisconsin: 'WI',
  wyoming: 'WY',
}

const allStates = {
  ...contiguousStates,
  alaska: 'AK',
  'american samoa': 'AS',
  'armed forces americas': 'AA',
  'armed forces europe': 'AE',
  'armed forces pacific': 'AP',
  guam: 'GU',
  'marshall islands': 'MH',
  'puerto rico': 'PR',
  'us virgin islands': 'VI',
}

// sort alphabetically
Object.keys(allStates)
  .sort()
  .forEach(key => {
    const value = allStates[key]
    delete allStates[key]
    allStates[key] = value
  })

// So happy that Canada and the US have distinct abbreviations
const provinces = {
  alberta: 'AB',
  'british columbia': 'BC',
  manitoba: 'MB',
  'new brunswick': 'NB',
  newfoundland: 'NF',
  'northwest territory': 'NT',
  'nova scotia': 'NS',
  nunavut: 'NU',
  ontario: 'ON',
  'prince edward island': 'PE',
  quebec: 'QC',
  saskatchewan: 'SK',
  yukon: 'YT',
}

const regions = Object.assign(allStates, provinces)

export const allStatesOptions = Object.keys(allStates).map(state => {
  return { label: startCase(state), value: allStates[state] }
})

export const contiguousStatesOptions = Object.keys(contiguousStates).map(state => {
  return { label: startCase(state), value: contiguousStates[state] }
})

/**
 * Convert a state or province name to its code
 * @param {string} input - The name of the state or province
 * @returns {string} The code for the state or province
 */
export function nameToCode(input = '') {
  input = input.trim().toLowerCase()

  if (input.length === 2) {
    return input.toUpperCase()
  }

  return (regions[input] || input).toUpperCase()
}

/**
 * Convert a state or province code to its name
 * @param {string} input - The code for the state or province
 * @returns {string} The name of the state or province
 */
export function codeToName(input) {
  if (!input || input.length > 2) {
    return input
  }

  input = input.trim().toUpperCase()

  let name = input

  Object.keys(regions).forEach(key => {
    if (regions[key] === input) {
      name = startCase(key)
    }
  })

  return name
}
